<style type="text/css">

    .c-calendar-month .c-day {
        float: left;
        display: block;
        padding:4px;
        width: 14.28%;
        position: relative;
    }

    .c-calendar-month .c-date {
        float: left;
        display: block;
        padding:4px;
        width: 14.28%;
        height: 140px;
        border-left: 1px solid #dddddd;
        position: relative;
    }

    .c-calendar-month .c-date label {
        cursor: pointer;
    }

    .c-calendar-month .c-week {
        clear: both;
    }

    .c-calendar-month .c-events {
        overflow-y: scroll;
        height: 100px;
    }

    .c-calendar-month .c-event {
        color:#fff;
        opacity: .9;
        cursor: pointer;
        padding:1px;
        border:1px solid #ffffff;
        text-wrap: avoid;
    }

    .c-calendar-month .c-event-title {
        text-overflow: ellipsis;
        overflow: hidden;
        width: 80%;
        padding-left: 3px;
        white-space: nowrap;
    }

    .c-calendar-month .c-event-content {
        text-overflow: ellipsis;
        overflow: hidden;
        width: 90%;
        padding-left: 3px;
        white-space: nowrap;
    }

    .c-calendar-month .c-event-bg {
        z-index: 2;
        background: #fff;
        opacity: .30;
    }

</style>

<template>
    <div class="c-calendar-month">
        <div class="c-header">
            <div class="c-day" :key="dayIndex" v-for="day, dayIndex in dataDays">
                <strong>{{day.label}}</strong>
            </div>
        </div>
        <div class="c-body">
            <div class="c-week" :key="weekIndex" v-for="week, weekIndex in dataWeeks">
                <div class="c-date" :key="dateIndex" v-for="date, dateIndex in week">
                    <label :style="buildDateStyle(date.date)" @click="$emit('onDateClick',date.date)">{{date.label}}</label>
                    <div class="c-events">
                        <div class="c-event"
                             @click="$emit('onEventClick', event, date.date)"
                             :key="eventIndex"
                             :style="buildEventStyle(event, date.date)"
                             v-for="event, eventIndex in retrieveEvents(date.date)">
                            <div class="c-event-title" v-html="renderEventTitle(event)"></div>
                            <div class="c-event-content" v-html="renderEventContent(event)"></div>
                            <div class="c-event-bg"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    export default {
        name: 'CalendarMonth',
        components: {
        },
        props: {
            options: {
                type: Object,
                default: function () {
                    return {
                        event: {
                          defaultBGColor: '#333333',
                        },
                        date: {
                            displayFormat: 'D MMM YYYY',
                            headerFormat: 'dddd',
                            firstDayOfWeek: 0
                        }
                    }
                }
            },
            value: {
                type: String,
                default: Vue.moment().format('YYYY-MM-DD')
            },
            events: {
                type: Array,
                default: function () {
                    return []
                }
            },
            onEventClick: {
                type: Function,
                default: function (event) {
                    return false
                }
            },
            onDateClick: {
                type: Function,
                default: function (date) {
                    return false
                }
            },
            renderEventTitle: {
                type: Function,
                default: function(event) {
                    return event.title
                }
            },
            renderEventContent: {
                type: Function,
                default: function(event) {
                    return ''
                }
            },
            renderEventAlt: {
                type: Function,
                default: function(event) {
                    return event.title
                }
            }
        },
        watch: {
            value(val) {
                this.dataDate = val
            },
            dataDate(val) {
                this.calculateDates()
                this.$emit('input', val)
            },
            dataEvents: {
                handler(val) {
                },
                deep: true
            }
        },
        mounted() {
            this.dataDate = this.value
            this.dataEvents = this.events
            this.calculateDates()
        },
        data: () => {
            return {
                Vue: Vue,
                dataWeeks: [],
                dataDays: [],
                dataEvents: [],
                dataDate: Vue.moment().format('YYYY-MM-DD')
            }
        },
        methods: {
            clearEvents() {
                this.dataEvents = []
            },
            updateEvent(event) {
                let eventIndex = Core.Array.findIndexByKey(this.dataEvents, 'id', event.id)
                if (eventIndex === false) {
                    this.dataEvents.push(event)
                } else {
                    let eventDates = Core.Array.newArray(this.dataEvents)
                    for(let eventDateIndex in eventDates) {
                        if(eventDates[eventDateIndex].id == event.id) {
                            eventDates[eventDateIndex] = event
                        }
                    }
                    this.dataEvents = []
                    this.dataEvents = eventDates
                }
            },
            calculateDates() {

                this.dataDays = []
                this.dataWeeks = []
                this.dataEvents = []

                for(let day = 1; day <= 7; day++) {
                    this.dataDays.push( { label: Vue.moment().weekday(day).format(this.options.date.headerFormat) } )
                }

                let monthStart = Vue.moment(this.dataDate).startOf('month')

                let monthStartDayOfWeek = Vue.moment(monthStart).format('d')
                monthStartDayOfWeek = 0 - (monthStartDayOfWeek-1)

                let start = Vue.moment(monthStart).add(monthStartDayOfWeek, 'days').format('YYYY-MM-DD')
                for (let weekIndex = 1; weekIndex <= 6; weekIndex++) {
                    let weekDates = []
                    for (let day = 0; day <= 6; day++) {
                        let weekDate = Vue.moment(start).add(day, 'days').format('YYYY-MM-DD')
                        let isToday = false
                        let isOut = false
                        if (Vue.moment(weekDate).format('YYYY-MM-DD') === Vue.moment().format('YYYY-MM-DD')) {
                            isToday = true
                        } else {
                            if (parseInt(Vue.moment(weekDate).format('MM')) !== parseInt(Vue.moment(this.dataDate).format('MM'))) {
                                isOut = true
                            }
                        }
                        weekDates.push({
                            label: Vue.moment(weekDate).format(this.options.date.displayFormat),
                            date: weekDate,
                            isOut: isOut,
                            isToday: isToday
                        })
                    }
                    this.dataWeeks.push(weekDates)
                    start = Vue.moment(start).add(7, 'days').format('YYYY-MM-DD')
                }

            },
            buildEventStyle(event, date) {
                if (undefined === event.color) {
                    event.color = ''
                }
                let color = Core.Color.hex(event.color, this.options.event.defaultBGColor)
                let style = 'background-color:' + color + ';'
                return style
            },
            buildDateStyle(date) {
                if (Vue.moment(this.dataDate).month() !== Vue.moment(date).month()) {
                    return 'color:#dddddd'
                }
            },
            retrieveEvents(date) {
                let events = []
                for (let eventIndex in this.dataEvents) {
                    let event = this.dataEvents[eventIndex]
                    if (Vue.moment(event.start).format('YYYY-MM-DD') === date) {
                        events.push(event)
                    }
                }
                return events
            }
        }
    }
</script>
